import { FC } from 'react';
import { Segmented } from 'antd';

import './index.scss';

type Props = {
  options: { value: boolean | string | any; label: string }[];
  onChange?: (value: string | number) => void;
  value?: string | number;
  disabled?: boolean;
};

export const AppSegmented: FC<Props> = ({ options, onChange, value, disabled }) => {
  return (
    <Segmented disabled={disabled} options={options} onChange={onChange} value={value} />
  );
};
